import useMainCategories from './useMainCategories'

const useFormattedCategories = (value = 'slug') => {
  const categories = useMainCategories()

  return categories.map((category) => ({ label: category.name, value: category[value] }))
}

export default useFormattedCategories
